// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"228":"83e67e72","244":"ced810e5","302":"b8ae4f61"}[chunkId] + ".chunk.js";
};